import { render, staticRenderFns } from "./BlogCards.vue?vue&type=template&id=7be0490f"
import script from "./BlogCards.vue?vue&type=script&lang=js"
export * from "./BlogCards.vue?vue&type=script&lang=js"
import style0 from "./BlogCards.vue?vue&type=style&index=0&id=7be0490f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports